export default {
  title_captain: {
    en: 'Captain',
    fr: 'Capitaine',
  },
  title_co_captain: {
    en: 'Co-Captain',
    fr: 'Co-Capitaine',
  },
  title_treasury: {
    en: 'Treasury',
    fr: 'Trésorerie',
  },
  title_logistics_helper: {
    en: 'Logistics Helper',
    fr: 'Aide à la logistique',
  },
  title_logistics_manager: {
    en: 'Logistics Manager',
    fr: 'Responsable Logistique',
  },
  title_project_manager: {
    en: 'Project Manager',
    fr: 'Responsable de Projet',
  },
  title_technical_director: {
    en: 'Technical Director',
    fr: 'Directeur Technique',
  },
  title_technical_director_f: {
    en: 'Technical Director',
    fr: 'Directrice Technique',
  },
  title_social_coordinator: {
    en: 'Social Coordiantor',
    fr: 'Coordinateur Social',
  },
  title_social_manager: {
    en: 'Social Manager',
    fr: 'Responsable Social',
  },
  title_event_manager: {
    en: 'Event Manager',
    fr: 'Responsable Événementiel',
  },
  title_partnership_manager: {
    en: 'Partnership Manager',
    fr: 'Responsable Partenariat',
  },
  title_merchandise_manager: {
    en: 'Merchandise Manager',
    fr: 'Responsable Marchandise',
  },
};
